import React, {useEffect, useState} from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import {useParams} from "react-router-dom";
import {firebase} from "../firebase/clientApp";
import {Edit} from "@mui/icons-material";
import axios from "axios";
import {API_URL, THEME_CONFIG} from "../config";
import {CustomAlert} from "./shared/CustomAlert";
import {useTranslation} from 'react-i18next';

export const DisplayName = ({userData, setUserData}) => {
  const {primary,} = THEME_CONFIG
  const {t} = useTranslation(['components', 'common', 'errors']);

  const {eventOwnerId, id} = useParams()
  const [state, setState] = useState({displayName: '', teamName: ''})
  const [error, setError] = useState(false)
  const [setting, setSetting] = useState(false)
  const [editing, setEditing] = useState(false)

  const [privacy, setPrivacy] = useState(false)

  useEffect(() => {
    if (userData) {
      setState(userData)
    }
  }, [userData])

  const handleSetDisplayName = (event) => {
    //if(event.target.value.length <= 20)
      setState({...state, displayName: event.target.value})
  }

  const handleSetTeam = (event) => {
    setState({...state, teamName: event.target.value})
  }

  const submitDisplayName = async (event) => {
    event.preventDefault()
    setSetting(true)
    let uid = firebase.auth().currentUser.uid
    await axios.post(`${API_URL}users/${eventOwnerId}/events/${id}/users`, {
      user: uid,
      displayName: state.displayName,
      teamName: state?.teamName ?? ""
    })
      .then(res => {
        setUserData({displayName: state.displayName ?? '', teamName: state.teamName ?? ''})
        setError("")
        setEditing(false)
      })
      .catch((err) => {
        console.log(t('errors:nicknameTaken'), err?.response?.data?.message ?? t('errors:generic'))
        setError(err?.response?.data?.message ?? t('errors:generic'))
      })
      .finally(() => {
        setSetting(false)
      })
  }

  return (
    <Box px={3} my={2}>
      {
        (userData.displayName === '' || !userData.displayName) ?
          <Box>
            <Box sx={{
              background: 'rgba(0,0,0,0.65)',
              width: '100%',
              height: '100vh',
              position: 'fixed',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: -1
            }}/>
            <Typography gutterBottom textAlign={'center'} fontSize={20}>
              {t('displayName.enterFullName')}
            </Typography>
            <form onSubmit={submitDisplayName}>
              <TextField
                fullWidth
                required
                inputProps={{style: {fontSize: '1.2rem'}}}
                placeholder={t('displayName.fullNamePlaceholder')}
                helperText={t('displayName.maxCharacters')}
                id="displayName"
                value={state.displayName}
                onChange={handleSetDisplayName}
                error={state.displayName.length > 20}
              />

              {!editing &&
                <Stack alignItems={'start'} py={3}>
                  <Typography variant="body2" fontWeight={'light'} color="textSecondary" textAlign={'left'}>
                    {t('displayName.privacyNotice')}
                    <br/><br/>{t('displayName.privacyDetails')} <i><a href={"/Privacy policy for ICA 2025.pdf"} style={{fontWeight: 'bold', color: primary}}>{t('displayName.privacyPolicy')}</a></i>.
                  </Typography>
                  <Stack mt={'20px'} ml={'-12px'} direction={'row'} alignItems={'center'} justifyContent={'center'}>
                    <Checkbox
                      required
                      name="presoVisioneInformativa"
                      onChange={(e) => setPrivacy(e.target.checked)}
                    />
                    <Typography variant="body2" fontWeight={'light'} color="textSecondary" textAlign={'left'}>
                      {t('displayName.acceptPrivacy')}
                    </Typography>
                  </Stack>
                </Stack>}

              <Box display={'flex'} justifyContent={'center'}>
                {editing && <Button sx={{color: 'white'}} onClick={() => setEditing(false)}>
                  {t('common:cancel')}
                </Button>}
                {setting ? <CircularProgress/> :
                  <Button variant={'default'} type={'submit'}
                          disabled={
                            (editing && userData.displayName === state.displayName)
                            || (!state.displayName || !privacy || state.displayName.length > 20)
                          }>
                    {t('common:submit')}
                  </Button>}
                <CustomAlert open={!!error} message={error} setOpen={setError} severity={'error'}/>
              </Box>
            </form>
          </Box>
          :
          <>
            <Stack>
              <Stack>
                <Typography textAlign={'center'} fontSize={18} sx={{mb: 0}}>
                  {t('displayName.hello')} <b>{userData.displayName.toUpperCase()}</b>
                </Typography>
                {userData?.teamName ? <Typography gutterBottom textAlign={'center'} fontSize={20} sx={{pb: 1}}>
                  {userData.teamName ? `${t('common:team')}${userData.teamName}` : ''}
                </Typography> : null}
              </Stack>
              {/*<Stack mt={'-10px'} direction={'row'} justifyContent={'center'} alignItems={'center'}>
                <Typography variant={'body2'}><i>{t('displayName.editNickname')}</i></Typography>
                <IconButton size={'small'} color={'primary'} onClick={() => setEditing(!editing)}>
                  <Edit fontSize={'small'}/>
                </IconButton>
              </Stack>*/}
            </Stack>
            {editing &&
              <Dialog open={editing} fullWidth maxWidth={'md'} onClose={() => setEditing(false)}>
                <DialogContent sx={{height: '25vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <form onSubmit={submitDisplayName}>
                    <TextField
                      fullWidth
                      required
                      inputProps={{style: {fontSize: '1.2rem'}}}
                      placeholder={t('displayName.fullNamePlaceholder')}
                      id="displayName"
                      value={state.displayName}
                      onChange={handleSetDisplayName}
                    />
                    <Box pt={2} display={'flex'} justifyContent={'space-evenly'}>
                      {editing && <Button sx={{color: 'white'}} onClick={() => setEditing(false)}>
                        {t('common:cancel')}
                      </Button>}
                      {setting ? <CircularProgress/> :
                        <Button variant={'contained'} type={'submit'}
                                disabled={
                                  (editing && userData.displayName === state.displayName) || (!state.displayName)
                                }>
                          {t('common:submit')}
                        </Button>}
                      <CustomAlert open={!!error} message={error} setOpen={setError}
                                   severity={'error'}/>
                    </Box>
                  </form>
                </DialogContent>
              </Dialog>
            }
          </>
      }

    </Box>
  )
}
